import { FC } from 'react';

import ExcipientListing from 'components/main/Excipient';

const Excipient: FC = () => <ExcipientListing />;

export default Excipient;
